<template>
  <div>
    <b-card title="Módulo de Reportes">
      <b-tabs pills>
        <b-tab title="Ocupación de Salones" active>
          <ClassroomOccupancy />
        </b-tab>
        <b-tab title="Carga Docente">
          <TeacherLoad />
        </b-tab>
        <b-tab title="Secciones por Curso">
          <SectionsByCourse />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTabs, BTab,
} from 'bootstrap-vue'
import ClassroomOccupancy from '@/components/reports/ClassroomOccupancy.vue'
import TeacherLoad from '@/components/reports/TeacherLoad.vue'
import SectionsByCourse from '@/components/reports/SectionsByCourse.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    ClassroomOccupancy,
    TeacherLoad,
    SectionsByCourse,
  },
}
</script>
